
import { BrowserRouter } from 'react-router-dom'
import '@assets/style/antd.css'
import { renderRoutes } from 'react-router-config';
import routes from './router/index'
import Store from '@store'
import { Suspense } from 'react'
import TokenLogin from './components/tokenLogin'

function App() {
  // const history = useHistory()
  // const { pathname, search } = useLocation()
  // const { token } = queryString.parse(search)
  // console.log(token);
  return (
    <div className="App">
      <Suspense fallback={<></>}>
        <BrowserRouter>
          <TokenLogin />
          <Store>
            {renderRoutes(routes)}
          </Store>
        </BrowserRouter>
      </Suspense>
    </div>
  )
}

export default App;
